import toggleBox from './toggleBox';
export default toggleBox;



// WEBPACK FOOTER //
// ./src/components/toggleBox/index.js